import { useContext } from 'react';

import {
  TribuApasionado,
  TribuApasionadoSmile,
  TribuInconformista,
  TribuInconformistaSmile,
} from '@/icons';
import { Text } from '@/atoms';
import { CardTribu, Prose } from '@/molecules';

import { InitPropsProvider } from '@/components/providers';

import type { ElementType } from 'react';

interface TypeUneteTribuDeArtesnaos {
  id: string;
  bloque: {
    title?: string | null;
    description?: string | null;
    titleColor?: string | null;
    descriptionColor?: string | null;
    headingType: ElementType;
  };
}

const UneteTribuDeArtesanos = ({ bloque, id }: TypeUneteTribuDeArtesnaos) => {
  const {
    options: { tribuAmantesArtesanos },
  } = useContext(InitPropsProvider);

  return (
    <div
      {...(id && { id })}
      className="md:py- u-wrapper relative flex flex-col gap-5 px-4 py-4"
    >
      {bloque?.title && (
        <Text
          style={{ color: bloque?.titleColor || '#262626' }}
          as={bloque.headingType || 'h2'}
          className="relative w-fit after:absolute after:-bottom-5 after:left-0 after:h-4 after:w-full after:bg-[url('/assets/images/underline.svg')] after:bg-no-repeat after:content-['']"
        >
          {bloque.title}
        </Text>
      )}

      {bloque?.description && (
        <Prose
          style={{ color: bloque?.descriptionColor || '#262626' }}
          className="mt-2"
          html={bloque.description}
        />
      )}

      <div className="flex flex-wrap items-stretch justify-center gap-8 md:gap-28">
        <CardTribu
          advantages={{
            title: 'Tus ventajas',
            advantages:
              tribuAmantesArtesanos?.advantagesInconformista.map(
                (advantage) => advantage.advantage || '',
              ) || [],
          }}
          color="#DDD3C7"
          HeaderIcon={TribuInconformista}
          TopIcon={TribuInconformistaSmile}
          headerTitle="Al realizar tu primer pedido"
          showRegisterButton
        />

        <CardTribu
          advantages={{
            title: 'Ventajas',
            advantages:
              tribuAmantesArtesanos?.advantagesApasionado?.map(
                (advantage) => advantage.advantage || '',
              ) || [],
          }}
          color="#F38D30"
          HeaderIcon={TribuApasionado}
          TopIcon={TribuApasionadoSmile}
          headerTitle="Por solo 19,90€ al año"
          showSubscriptionButton
        />
      </div>
    </div>
  );
};

export default UneteTribuDeArtesanos;
